import { z } from 'zod';

/**
 * Política de senha do backend (`modules/auth/auth.schemas.ts`), repetida aqui para avisar antes
 * de enviar — quem decide continua sendo o servidor. Comprimento, não regra de composição.
 */
export const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 256;

export const newPassword = z
  .string()
  .min(MIN_PASSWORD_LENGTH, `Use pelo menos ${MIN_PASSWORD_LENGTH} caracteres.`)
  .max(MAX_PASSWORD_LENGTH, `Use no máximo ${MAX_PASSWORD_LENGTH} caracteres.`);

/** Senha nova e a repetição, com o erro de "não conferem" no campo da repetição. */
export const newPasswordWithConfirmation = z
  .object({ password: newPassword, confirmation: z.string() })
  .refine((value) => value.password === value.confirmation, {
    message: 'As senhas não conferem.',
    path: ['confirmation'],
  });

/** Código de 6 dígitos do aplicativo autenticador. */
export const totpCode = z
  .string()
  .trim()
  .regex(/^\d{6}$/, 'O código tem 6 dígitos.');
